import { Carto } from '@workspaces/types'
import { getInstance as getAuth0ServiceInstance } from '@/auth/index'

export default class BrowserCartoAuthorizer implements Carto.CartoAuthorizer {
  getToken(): string {
    return getAuth0ServiceInstance().getAccessTokenCartoV3() ?? ''
  }
}
